import * as ActionTypes from './../constants';
import { baseUrl } from './../index';
// import { AsyncStorage } from 'react-native';
import axios from 'axios';
import { getUserToken } from './../getUserToken';

export default function (state={},action){
    switch(action.type){
        case ActionTypes.REQUEST_DISCLAIMER:

        return {
            ...state,
            loading:true,
            error:false,
            errorInfo:null
        }

        case ActionTypes.RECEIVED_DISCLAIMER:

        return {
            ...state,
            loading:false,
            response:action.res,
            error:false,
            errorInfo:null
        }

        case ActionTypes.ERROR_DISCLAIMER:
        return {
            ...state,
            loading:false,
            error:true,
            response: null,
            errorInfo:action.err
        }

        case ActionTypes.CLEAR_DISCLAIMER:
        return {}
        default : return state
    }
} 

const dispatchRequestDisclaimer = () => ({
    type: ActionTypes.REQUEST_DISCLAIMER
})

const dispatchReceivedDisclaimer = res => ({
    type: ActionTypes.RECEIVED_DISCLAIMER,
    res
})

const dispatchErrorDisclaimer = err => ({
    type: ActionTypes.ERROR_DISCLAIMER,
    err
})

const dispatchClearDisclaimer = () => ({
    type: ActionTypes.CLEAR_DISCLAIMER
})

export const clearDisclaimerData = () => dispatchClearDisclaimer();


export const getDiscalimer = discalimerData => dispatch => { 
    getUserToken()
        .then(token => {
            dispatch(dispatchRequestDisclaimer());   
            const options = {
                method: 'post',
                url: `${baseUrl}/api/disclaimer`, 
                data: discalimerData,     
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }         
            return axios(options).then( ({data}) => {
                dispatch(dispatchReceivedDisclaimer(data));
            })            
        }) 
        .catch(e => dispatch(dispatchErrorDisclaimer(e)));
}
